import React from "react";
import styled from "styled-components";
import { CgProductHunt } from "react-icons/cg";
import { AiOutlineMenu, AiOutlineShoppingCart } from "react-icons/ai";
// import pic from "./ASSESTS/TWO.png";
import pic from "./ASSESTS/Food/logoo.png";
import { Link } from "react-router-dom";

import { UseAppDispatch, useAppSelector } from "./Global/Store";
import { logoutUser } from "./Global/ReduxState";
import { MdCancelPresentation } from "react-icons/md";
import DropDown from "./DropDown";

const Header = () => {
  const userName = useAppSelector((state) => state.currentUser);
  const dispatch = UseAppDispatch();

  const readCartQuantity = useAppSelector((state) => state.totalQuantity);

  const [show, setShow] = React.useState(false);

  const toggle = () => {
    setShow(!show);
  };

  return (
    <div>
      <Hold>
        <Container>
          <Wrapper to="/">
            <Logo src={pic} />
          </Wrapper>
          {/* <NavHold>
            <Nav to="/">Home</Nav>
            <Nav to="/about">Purchases</Nav>
            <Nav to="/product">Products</Nav>
            <Nav to="/cart">Cart</Nav>
          </NavHold> */}

          <IconHold>
            <Icon to="/product">
              <CgProductHunt />
              <span>Products</span>
            </Icon>
            <Icon1 to="/cart">
              <AiOutlineShoppingCart />

              <Count> {readCartQuantity}</Count>
              <span>Cart</span>
            </Icon1>

            {/* <Icon></Icon> */}
            {userName?.name ? (
              <>
                <Link
                  onClick={() => {
                    dispatch(logoutUser());
                  }}
                  to="/home"
                >
                  <Button>LogOut</Button>
                </Link>
              </>
            ) : (
              <>
                <Link to="/register">
                  <Button>Get Started</Button>
                </Link>
              </>
            )}
          </IconHold>
          <DivFour onClick={toggle}>
            {show ? (
              <P2>
                <MdCancelPresentation />
              </P2>
            ) : (
              <P1>
                <AiOutlineMenu />
              </P1>
            )}
            {/* <div style={{display:"flex" , alignItems:"center"}}>
            <Icon to="/product">
            
             <p style={{fontSize:"12px"}}>
               Products
             </p>
             
            </Icon>
            <Icon1 to="/cart">
              
              <AiOutlineShoppingCart />

              <Count> {readCartQuantity}</Count>
             
            </Icon1>
            </div> */}
          </DivFour>
        </Container>
        {show ? (
          <DropHold>
            <DropDown />
          </DropHold>
        ) : null}
      </Hold>
    </div>
  );
};

export default Header;

const P2 = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  /* background-color: red; */
  width: 200px;

  /* @media screen and (min-width: 320px ) and (max-width: 375px) {
    width: 200px;
  } */

  @media screen and (max-width: 320px) {
    width: 200px;
  }
  @media screen and (min-width: 375px) and (max-width: 500px) {
    width: 250px;
  }
`;

const P1 = styled.div``;

const DropHold = styled.div`
  @media screen and (max-width: 500px) {
    width: 300px;
  }
`;

const Count = styled.div`
  height: 15px;
  width: 15px;
  border-radius: 50%;
  background-color: black;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
`;

const Button = styled.button`
  width: 100px;
  height: 40px;
  background-color: #123456;
  /* background-color: black; */
  /* background-color: #ffc547; */
  color: white;
  outline: none;
  font-weight: 700;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  margin-left: 10px;
  transition: all 0.5s ease-in-out;

  :hover {
    background-color: white;
    color: black;
    transform: scale(0.99);
    box-shadow: 0px 0px 0.5px 1px rgba(0, 0, 0, 0.1);
  }
`;

const Icon = styled(Link)`
  margin-right: 5px;
  margin-left: 5px;
  color: #000000e6;
  cursor: pointer;
  font-weight: 500;
  font-size: 20px;
  text-decoration: none;
  display: flex;
  align-items: center;

  span {
    margin-left: 5px;
    font-weight: 500;
  }
`;

const Icon1 = styled(Link)`
  margin-right: 5px;
  color: #000000e6;
  cursor: pointer;
  font-weight: 500;
  font-size: 20px;
  display: flex;
  align-items: center;
  margin-left: 10px;
  cursor: pointer;
  text-decoration: none;

  span {
    margin-left: 5px;
    font-weight: 500;
  }
`;

const IconHold = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    display: none;
    /* display: flex; */
    /* justify-content: flex-end;
    align-items: flex-end; */
  }
`;

// const Nav = styled(NavLink)`
//   margin-right: 10px;
//   margin-left: 10px;
//   /* color: #eaded0; */
//   color: black;
//   font-weight: 500;
//   cursor: pointer;
//   text-decoration: none;
// `;

// const NavHold = styled.div`
//   display: flex;
// color: #eaded0;
//   @media screen and (max-width: 500px) {
//     display: none;
//     /* display: flex; */
//     /* justify-content: flex-end;
//     align-items: flex-end; */
//   }
// `;

const Logo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Wrapper = styled(Link)`
  width: 100px;
  height: 90px;
  /* background-color: indigo; */
`;

const Container = styled.div`
  width: 90%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Hold = styled.div`
  width: 100%;
  height: 90px;
  /* background-color: #ffffffb2; */
  /* background-color: #79171d; */
  box-shadow: 0px 0px 0.5px 1px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;

  margin-bottom: 30px;
  /* background-color: #3AAF7B; */
  /* background-color: #90EE90; */
  /* background-color: #578A53; */
  /* background-color: #2AFC98; */
  background-color: #09e85e;
  /* background-color: #2AFC98; */
  /* background-color: #2AFC98; */
  background-color: emerald;
  z-index: 99999999;
  @media screen and (max-width: 768px) {
    margin-bottom: 50px;
    /* display: flex; */
    /* justify-content: flex-end;
    align-items: flex-end; */
  }
`;

const DivFour = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: block;

    /* display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    background-color: rebeccapurple; */
    /* width: 80%; */
  }
`;
